import qs from "qs";
import { useCallback, useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ContentsTitle } from "src/components";
import HistoryDetail from "src/components/histroy/HistoryDetail";
import useNavigate from "src/hooks/usePartnerNavigate";
import BasicInfoDetail from "./basicInfoDetail/BasicInfoDetail";

/*
  공용공간 요금 > 상세
 */
const tabs = [
  { value: "basicInfo", label: "기본정보" },
  { value: "history", label: "변경내역" },
];

const PriceDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  // location search (url query parameter) 를 읽어서 object 로 변환
  // decoder를 지정하지 않으면 DetailLink가 붙인 encode된 list 파라미터가 디코딩되어
  // 목록 필터(sort=id, searchType 등)가 top-level로 흩어지고, 변경내역 탭의 audit API 요청에 섞여 400을 유발함.
  // 공용 ContentsTitle과 동일하게 값 디코딩을 막아 list를 불투명한 단일 파라미터로 유지한다.
  const queryParams = useMemo(
    () =>
      qs.parse(location.search, {
        ignoreQueryPrefix: true,
        allowDots: true,
        decoder: (value) => value,
      }),
    [location],
  );

  // 현재 활성화 되어야하는 tab
  const activeTab = useMemo(() => {
    if (queryParams?.tab) {
      return tabs.find((tab) => tab.value === queryParams?.tab);
    }
    return tabs[0];
  }, [queryParams]);

  // 탭 클릭시 callback 함수
  const clickTab = useCallback(
    (tab: { value: string; label: string }) => {
      const newQueryParams = { ...queryParams };
      if (newQueryParams?.tab) {
        delete newQueryParams.tab;
      }

      newQueryParams.tab = tab.value;

      // query parameter 에 tab 추가
      const newQueryParamStr = qs.stringify(newQueryParams, { allowDots: true });
      navigate(location.pathname + "?" + decodeURIComponent(newQueryParamStr));
    },
    [navigate, location, queryParams],
  );

  return (
    <div className="">
      <ContentsTitle
        title="공용공간 요금"
        tabs={tabs}
        activeTab={activeTab}
        clickTab={clickTab}
        detailInfo={[{ title: "공용공간 요금 ID", value: params.id ? params.id : "" }]}
      />
      {activeTab?.value === "basicInfo" && <BasicInfoDetail />}
      {activeTab?.value === "history" && params.id && <HistoryDetail identifier={{ priceRuleId: String(params.id) }} />}
    </div>
  );
};
export default PriceDetail;
